export default __webpack_public_path__ + "static/media/StateHelplines.4a3fe3a7.PNG";